<template>
  <div id="app" >
      <vheader v-if=" $route.name&&$route.name != 'test'&&$route.name != 'vr'&&$route.name !='ccwc'" ></vheader>
      <router-view :key="$route.fullPath" />
    
  </div>
</template>


<script>
import {getDisplay} from "@/api/api.js"
import vheader from './components/header.vue'
import "element-ui/lib/theme-chalk/display.css";
export default {
  components: { vheader },
  beforeCreate() {
            document.querySelector('body').setAttribute('style', 'margin:0%')
  },
  mounted() {
    getDisplay().then((res)=>{
      window.localStorage.setItem('state',res.data[0].state)
      console.log(res)
    })
  },
}
</script>

<style>

</style>
